import { HashRouter, Route, Routes } from "react-router-dom";
import Error404 from "./pages/Error404";
import Login from "./pages/Login";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
  return (
    <>
      <HashRouter>
        <Routes>
          <Route exact path="/" element={<Login />} />
          <Route path="/*" element={<Error404 />} />
        </Routes>
      </HashRouter>
      <ToastContainer theme="colored" />
    </>
  );
}

export default App;
